import api from '../../../Services/API';

// OBTÉM A LISTA DOS ARTIGOS DA ORDEM DE FABRICO \ YWFORARTOF
export async function moverCard(_card, destination, lang) {
    const token = localStorage.getItem('token');
    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
            'content-type': 'application/json',
        },
    };

    var card = {id: _card};

    return api.post(`backend/negocios/etapa/${lang}/${destination}/${_card}`, card, config).then(res => {
        return res;
    });
}
